module.exports = __webpack_public_path__ + "img/list_blue.866f79fd.svg";